import { Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ErrorMessage } from '../../../models/error.model'

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnInit {
  @Input() errorMessage: ErrorMessage
  constructor(private readonly router: Router) {}

  ngOnInit(): void {}

  onErrorButtonClicked(): void {
    if (this.errorMessage.url) {
      this.router.navigate([this.errorMessage.url])
    }
  }
}
